import { useMemo } from "react";

export function countUnreadMessages(chat: TicketChat[] | undefined): number {
  if (!chat || chat.length === 0) {
    return 0;
  }

  return chat.filter(
    (message) => message.user_type === "staff" && message.viewed_at === null
  ).length;
}

export function hasUnreadMessages(chat: TicketChat[] | undefined): boolean {
  return countUnreadMessages(chat) > 0;
}

export function useUnreadMessages(chat: TicketChat[] | undefined) {
  return useMemo(() => {
    const count = countUnreadMessages(chat);
    const hasUnread = hasUnreadMessages(chat);

    return {
      count,
      hasUnread,
      isEmpty: count === 0,
      isNotEmpty: count > 0,
    };
  }, [chat]);
}
